import { render } from "./DesignPage.vue?vue&type=template&id=2906a8fa"
import script from "./DesignPage.vue?vue&type=script&lang=js"
export * from "./DesignPage.vue?vue&type=script&lang=js"

import "./DesignPage.vue?vue&type=style&index=0&id=2906a8fa&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__